/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function Products(state = {}, action) {
    switch (action.type) {
    case ProductConstants.GET_PRODUCTS_LIST_SUCCESS:
        return {
            type: ProductConstants.GET_PRODUCTS_LIST_SUCCESS,
            list: action.user.data.data,
            pagination: action.user.data.number_of_pages,
            STOCK_VISIBILITY: action.user.data.STOCK_VISIBILITY,
        };
    case ProductConstants.GET_PRODUCTS_LIST_FAILURE:
        return {
            type: ProductConstants.GET_DISTRIBUTORS_SUCCESS,
            message: action.message,
        };

    default:
        return state;
    }
}
